<template>
  <div class="link-button">
    <v-btn
      :href="url"
      flat
      :ripple="ripple"
      :disabled="disabled"
      :color="color"
      :target="target"
      @click.prevent="clicked"
      :class="className"
    >
      <slot></slot>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    ripple: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    target: {
      type: String,
      default: '_self',
    },
    url: {
      type: String,
      default: '/',
    },
    className: {
      type: [Object, String],
      default: '',
    },
  },
  data: () => ({
    processing: false,
  }),
  methods: {
    clicked() {
      // terminate the function
      // if an async request is processing
      if (this.processing === true) {
        return;
      }

      // set the async state
      this.processing = true;

      this.$emit('clicked');

      const self = this;
      // simulating the async request
      setTimeout(() => {
        // on success or failure
        // reset the state
        self.processing = false;
      }, 1500);
    },
  },
};
</script>

<style>
.link-button > .v-btn {
  text-transform: unset;
  margin: 0;
  min-width: unset;
  padding: 0;
  height: auto;
}
.link-button > .v-btn--active:before,
.link-button > .v-btn:focus:before,
.link-button > .v-btn:hover:before {
  background-color: transparent !important;
}
.link-button > .v-btn:hover {
  text-decoration: underline;
}
</style>
